/**
 * @cb/sdk - UMD Bundle Entry Point
 *
 * Ce fichier définit l'API publique du bundle UMD destiné aux apps HTML
 * qui chargent le SDK via <script src="..."></script>.
 *
 * Le bundle expose window.CBSDK avec toutes les fonctions nécessaires.
 *
 * @packageDocumentation
 */

// =============================================================================
// CORE SDK - Re-exports depuis les modules existants
// =============================================================================

export { createCBClient } from './client';
export type { CBClient, CreateCBClientOptions } from './client';

export {
  signInWithGoogle,
  signOut,
  getSession,
  getCurrentAgent,
} from './auth';
export type { SignInWithGoogleOptions, CurrentAgent } from './auth';

export { absorbOAuthCallback } from './auth-helpers';

// =============================================================================
// HELPERS HTML - Pour simplifier l'usage dans les apps non-bundlées
// =============================================================================

export { createApp, requireAuth } from './umd/helpers';
export type { CBConfig, RequireAuthOptions } from './umd/helpers';

// =============================================================================
// VERSION
// =============================================================================

export const SDK_VERSION = '0.2.0';
